<template lang="pug">
.modal-overlay(v-if="visible", @click.self="$emit('close')")
  .modal-content
    header.modal-header
      slot(name="header") Überschrift
    section.modal-body
      slot(name="body")
    footer.modal-footer
      slot(name="footer")
</template>

<script>
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";

export default {
  name: "Modal",
  components: { Icon, Button3d },
  props: {
    visible: { type: Boolean, required: true },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  width: 90vw;
  height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

.modal-header {
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  flex: 1;
  overflow: auto;
}

.modal-footer {
    display:flex;
    justify-content: space-evenly;
  padding: 0.75rem 1rem;
  border-top: 1px solid #ddd;
  text-align: right;
  background: #f9f9f9;
}
</style>
